export enum SortStowageColumnEnum {
    NoSort,
    CargoNr,
    TradeName,
    ProductName,
    NotStowedWeight,
    NotStowedVolume,
    StowedWeight,
    StowedVolume,
    NominatedWeight,
    NominatedVolume,
    OperationType,
    PortNames,
    Sequence,
}
